import { render } from "./ThePositionCreateButton.vue?vue&type=template&id=55902f00&ts=true"
import script from "./ThePositionCreateButton.vue?vue&type=script&lang=ts"
export * from "./ThePositionCreateButton.vue?vue&type=script&lang=ts"

import exportComponent from "/data/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__